import { FeatureFlagKeys } from '../../../constants/ff.posthog';
import { evaluateFlagForDistinctId } from '../../../services/posthog/evaluateFlagForDistinctId';
import { parseLikelyToFillBands } from '../likelyToFill';

/**
 * The office's arm of the Likely to Fill test (GOTU-13065) and its bands,
 * evaluated as the office (its user id is its PostHog distinct id in the apps).
 * A failed or skipped lookup reads as no variant, which the forms treat as
 * control.
 *
 * @param {string} officeId - Office (dentist) user id
 * @returns {Promise<{ variant: string|boolean|null, bands: typeof import('../likelyToFill').DEFAULT_LIKELY_TO_FILL_BANDS }>}
 */
export const getLikelyToFillExperiment = async (officeId) => {
  const flag = await evaluateFlagForDistinctId(FeatureFlagKeys.likelyToFillIndicator, officeId);

  return {
    variant: flag?.variant ?? null,
    bands: parseLikelyToFillBands(flag?.payload),
  };
};
